import { bannerTitleColors } from '@/constants';
import { BannerStatus, TextAppearanceKeys, TextEmphasisKeys, TextSizeKeys } from '@/constants/enum';
import { handleGetTextColor, handleGetTextEmphasis, handleGetTextSize } from '@/helpers/common';
import { BannerStatusCardStyled } from '@/pages/Checkout/components/BannerStatusCard/styled';
import { Collapsible, Icon } from '@shopify/polaris';
import { ChevronDownIcon, ChevronUpIcon, XIcon } from '@shopify/polaris-icons';
import parse from 'html-react-parser';
import { useEffect, useState } from 'react';

interface IProps {
  backgroundColor: string;
  contentColor: string;
  icon: string;
  title?: string;
  onClick?: () => void;
  selected?: boolean;
  messageColor?: TextAppearanceKeys;
  messageSize?: TextSizeKeys;
  messageEmphasis?: TextEmphasisKeys;
  dataCard?: {
    title: string;
    content: string[];
    collapse: boolean;
    close: boolean;
    status?: BannerStatus;
  };
}

export default function BannerStatusCard({
  backgroundColor,
  contentColor,
  icon,
  title,
  dataCard,
  onClick,
  selected,
  messageColor,
  messageEmphasis,
  messageSize,
}: IProps) {
  const [expanded, setExpanded] = useState(!dataCard?.collapse ?? false);

  useEffect(() => {
    setExpanded(!dataCard?.collapse);
  }, [dataCard?.collapse]);

  return (
    <BannerStatusCardStyled
      backgroundColor={backgroundColor}
      contentColor={contentColor}
      selected={selected}
      style={{ cursor: dataCard ? 'default' : 'pointer' }}
      onClick={onClick}
      messageColor={handleGetTextColor(messageColor || TextAppearanceKeys.base)}
      messageSize={handleGetTextSize(messageSize || TextSizeKeys.base)}
      messageEmphasis={handleGetTextEmphasis(messageEmphasis || TextEmphasisKeys.base)}
      titleColor={bannerTitleColors[dataCard?.status as keyof typeof bannerTitleColors] || bannerTitleColors[BannerStatus.info]}
    >
      <div className="d-flex flex-column align-center">
        <div className="banner-status-card d-flex">
          <div className="status-card-item">{parse(icon)}</div>
          <div className={`status-card-content`}>
            {dataCard ? (
              <>
                <div className="content-between">
                  <p className="status-card-content-title">{dataCard.title}</p>
                  <div className="d-flex gap-12 align-center">
                    {dataCard?.collapse ? (
                      <div className="cursor-pointer" onClick={() => setExpanded((prev) => !prev)}>
                        <Icon source={expanded ? ChevronUpIcon : ChevronDownIcon} />
                      </div>
                    ) : null}
                    {dataCard?.close ? (
                      <div className="cursor-pointer">
                        <Icon source={XIcon} />
                      </div>
                    ) : null}
                  </div>
                </div>
                <Collapsible transition={{ duration: '500ms' }} open={expanded} id="test">
                  <div className="mt-4">
                    {dataCard.content.map((item, index) => (
                      <p className="status-card-content-text" key={index}>
                        {item}
                      </p>
                    ))}
                  </div>
                </Collapsible>
              </>
            ) : (
              <>
                <div className="status-card-content-title-empty"></div>
                <div className="status-card-content-text-empty"></div>
              </>
            )}
          </div>
        </div>
        {title ? <p className="mt-4">{title}</p> : null}
      </div>
    </BannerStatusCardStyled>
  );
}
